import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import CustomDialog from "./Dialog";
import searchIcon from "./assets/img/ui-search-icon-round.svg";

function SingleProductPage({}) {
  const navigate = useNavigate();

  const url = useLocation();
  const currentLocation = url.pathname;
  const segments = currentLocation.split("/"); // Split the URL string by slashes
  const productId = segments[segments.length - 1];
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [product, setProduct] = useState(null);
  const [material, setMaterial] = useState("");
  const [relatedProducts, setRelatedProducts] = useState(null);
  const [count, setCount] = useState("");

  const fetchProduct = async () => {
    try {
      const response = await axios.get(
        `https://bbjlatavola.com/wp-json/products/v1.0/products/${productId}`
      );

      setMaterial(response.data.material);
      setProduct(response.data.products[0]);
      setCount((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  };
  const fetchRelated = async () => {
    try {
      const response = await axios.get(
        `https://bbjlatavola.com/wp-json/products/v1.0/products?exclude=${productId}&sort=product-cat-low&filters={"materials":["${material}"]}`
      );

      setRelatedProducts(response.data.products);
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  };

  const handleOpenDialog = (product) => {
    setSelectedProduct(product);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    fetchProduct();
  }, [productId]);
  useEffect(() => {
    fetchRelated();
  }, [count]);

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <Container maxWidth="md">
      <Grid
        container
        sx={{
          mt: 5,
          paddingBottom: "70px",
        }}
        spacing={2}
      >
        <Grid item xs={12} sm={6} md={6}>
          <div style={{ position: "relative" }}>
            {" "}
            <img
              width="100%"
              src={product?.featured_image}
              alt={`Product ${product?.slug}`}
            />
            <div
              style={{
                position: "absolute",
                bottom: "10px ",
                right: "10px",
                cursor: "pointer",
              }}
            >
              <img src={searchIcon} onClick={() => handleOpenDialog(product)} />
            </div>
          </div>

          <CustomDialog
            open={dialogOpen}
            handleClose={handleCloseDialog}
            image={selectedProduct?.featured_image}
            title={selectedProduct?.name}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              paddingLeft: "32px",
            }}
          >
            <Typography className="single-product-title" variant="h5">
              {product?.name}
            </Typography>
            <Typography className="sizes-intro">Available Sizes</Typography>
            {product?.single_products.map((single_product, index) => {
              const str = single_product?.post_title;
              const hyphenIndex = str.indexOf("-"); // Find the index of the hyphen
              const desiredSubstring =
                hyphenIndex !== -1 ? str.substring(0, hyphenIndex).trim() : str;
              return (
                <p className="sizes" key={index}>
                  {desiredSubstring}
                </p>
              );
            })}
          </Box>
        </Grid>
      </Grid>
      <Divider />

      {relatedProducts?.length > 0 ? (
        <Grid container spacing={2}>
          <Grid
            item
            sx={{
              paddingTop: "48px",
            }}
            xs={12}
            sm={12}
            md={12}
          >
            <Typography className="heading-subject">
              Same Fabric Products
            </Typography>
            {relatedProducts?.map((product, index) => (
              <Grid
                sx={{
                  display: "flex",
                }}
                item
                key={index}
                xs={12}
                sm={3}
                md={3}
              >
                <div className="product-main">
                  <div className="product">
                    <img
                      width="100%"
                      src={product?.featured_image}
                      alt={`Product ${index}`}
                    />
                  </div>

                  <div className="product-hover">
                    <h2
                      className="title"
                      onClick={() => {
                        navigate(`/products/${product?.post_id}`);
                      }}
                    >
                      {product?.name}
                    </h2>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ) : null}
    </Container>
  );
}

export default SingleProductPage;
